import {AxisLabelsFormatterContextObject, Options} from 'highcharts';
import {registerPlugin} from "surveylabJsAssets/chart/charts";
import {Bar as SLBar} from "surveylabJsAssets/chart/plugin/bar";

export class Bar extends SLBar {
    protected allChartOptions(): Options {
        const yAxisLabels: Array<string> = $('#chart-texts').data('raw-labels');
        const options: Options = {
            chart: {
                type: 'bar',
                marginRight: 40,
                marginLeft: 10,
                spacingBottom: 25,
                spacingTop: 0,
                width: 580,
                height: 572
            },
            xAxis: {
                labels: {
                    // xAxis is labelled separately outside the chart
                    enabled: false
                }
            },
            yAxis: {
                labels: {
                    formatter: function (this: AxisLabelsFormatterContextObject) {
                        return yAxisLabels[<number>this.value] ?? this.value.toString();
                    },
                    enabled: true,
                    useHTML: true,
                    y: 15,
                    style: {
                        color: 'black',
                        fontSize: '10px',
                        fontWeight: '400'
                    },
                },
                tickPositions: [0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100],
                title: {
                    style: {
                        color: 'black',
                        fontSize: '14px',
                        fontWeight: '600'
                    },
                }
            },
            plotOptions: {
                bar: {
                    borderWidth: 0,
                    pointWidth: 11 // Bar height
                }
            },
        }

        return super.mergeOptions(super.allChartOptions(), options);
    }
}

export default function () {registerPlugin(Bar)}